import { render, staticRenderFns } from "./IconImpersonate.vue?vue&type=template&id=6f1b4dba&"
import script from "./IconImpersonate.vue?vue&type=script&lang=js&"
export * from "./IconImpersonate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f1b4dba')) {
      api.createRecord('6f1b4dba', component.options)
    } else {
      api.reload('6f1b4dba', component.options)
    }
    module.hot.accept("./IconImpersonate.vue?vue&type=template&id=6f1b4dba&", function () {
      api.rerender('6f1b4dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconImpersonate.vue"
export default component.exports